import type { CSSProperties, ReactNode } from "react";
import "./fx.css";

/**
 * ReactBits shiny-text 포팅 (home-ui-spec §2.2·§8). 그라디언트 마스크 스윕
 * 1회만(iteration-count:1) — 원본의 무한 루프 제거(§0-1). 종료 후 정적 텍스트.
 * reduced-motion 시 스윕 없음(fx.css).
 */
export interface ShinyTextProps {
  children: ReactNode;
  className?: string;
  /** 스윕 시간 ms (§7.1: 1800) */
  duration?: number;
  /** 시작 지연 ms — 로드 시퀀스 4번(§7.1: 600) */
  delay?: number;
}

export function ShinyText({
  children,
  className,
  duration = 1800,
  delay = 0,
}: ShinyTextProps) {
  return (
    <span
      className={`ty-fx-shiny ${className ?? ""}`}
      style={
        {
          "--fx-shine-duration": `${duration}ms`,
          "--fx-shine-delay": `${delay}ms`,
        } as CSSProperties
      }
    >
      {children}
    </span>
  );
}
